"use client"

import { useState } from 'react'
import { QRCodeSVG } from 'qrcode.react'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { useInstallPrompt } from '@/hooks/use-install-prompt'
import { IosInstallGuide } from './IosInstallGuide'

interface Props {
  siteUrl?: string
}

export function InstallCTACompact({ siteUrl }: Props) {
  const t = useTranslations('pwa.install')
  const { isStandalone, platform, canPromptInstall, canShowIosGuide, promptInstall } = useInstallPrompt()
  const [iosGuideOpen, setIosGuideOpen] = useState(false)

  if (isStandalone) return null

  const baseUrl = siteUrl || (typeof window !== 'undefined' ? window.location.origin : 'https://salaria.top')
  const qrUrl = `${baseUrl}?src=qr`

  return (
    <div>
      <h3 className="text-xs font-semibold uppercase tracking-wider mb-2">
        {t('title')}
      </h3>

      <div className="flex flex-wrap gap-x-2 gap-y-1 text-[10px] opacity-60 mb-3">
        <span>{t('badges.https')}</span>
        <span>·</span>
        <span>{t('badges.size')}</span>
        <span>·</span>
        <span>{t('badges.offline')}</span>
      </div>

      <div className="flex items-start gap-3">
        {/* QR слева */}
        <div className="p-2 rounded-lg bg-white shrink-0">
          <QRCodeSVG value={qrUrl} size={88} level="M" />
        </div>

        {/* Кнопки справа */}
        <div className="flex flex-col gap-2 min-w-0">
          <button
            onClick={() => setIosGuideOpen(true)}
           className="flex items-center gap-2 px-3 py-2 rounded-lg border border-zinc-200 hover:border-zinc-400 bg-white transition-all text-left"
          >
            <Image src="/pwa/safari-white.png" alt="" width={24} height={24} className="shrink-0" />
            <div className="flex flex-col leading-tight">
              <span className="text-[9px] uppercase tracking-wide opacity-60">{t('ios.prefix')}</span>
              <span className="text-[13px] font-semibold">{t('ios.platform')}</span>
            </div>
          </button>

          <button
            onClick={() => canPromptInstall && promptInstall()}
            disabled={!canPromptInstall && platform !== 'unknown' && platform !== 'desktop'}
           className="flex items-center gap-2 px-3 py-2 rounded-lg border border-zinc-200 hover:border-zinc-400 bg-white transition-all text-left disabled:opacity-40"
          >
            <Image src="/pwa/android-white.png" alt="" width={24} height={24} className="shrink-0" />
            <div className="flex flex-col leading-tight">
              <span className="text-[9px] uppercase tracking-wide opacity-60">{t('android.prefix')}</span>
              <span className="text-[13px] font-semibold">{t('android.platform')}</span>
            </div>
          </button>
        </div>
      </div>

      

      {canShowIosGuide && (
        <IosInstallGuide open={iosGuideOpen} onClose={() => setIosGuideOpen(false)} />
      )}
    </div>
  )
}